<template>
<div>
<div class="inServ">
  <el-row>
    <el-button type="primary" class="addMems fr" plain @click="serviSurp">调整会员剩余服务次数</el-button>
  </el-row>
  <el-row>
    <el-table :data="tableData" :span-method="objectSpanMethod" ref="multipleTable" border style="width: 100%; margin-top: 30px" :cell-class-name="tableRowClassName" :header-cell-style="{background:'#EFF1F5'}" >
      <el-table-column prop="memberName" label="会员名称" align="center"></el-table-column>
      <el-table-column prop="memberPhone" label="会员手机" align="center"></el-table-column>
      <el-table-column prop="goodsName" label="服务项目" align="center"></el-table-column>
      <el-table-column prop="courseStyle" label="服务项目总次数" align="center">
        <template slot-scope="scope">
          {{scope.row.courseStyle == 1 ? scope.row.containFrequency : '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="consumeFrequency" label="消费次数" align="center"></el-table-column>
      <el-table-column prop="residueFrequency" label="剩余次数" align="center">
        <template slot-scope="scope">
          {{scope.row.courseStyle == 1 ? scope.row.residueFrequency : '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="amount3" label="操作" align="center">--</el-table-column>
    </el-table>
  </el-row>
  <el-row>
    <el-col :span="24" style="margin-top:50px;text-align:center;">
      <el-button class="darkBtn" @click="closeTab(1)">关闭</el-button>
    </el-col>
  </el-row>
</div>
  <el-dialog title="调整会员剩余服务" :visible.sync="dialogVisibleBas" :center="true" width="580px">
    <publicBox :serviceArr='serviceArr' :memberNmu='memberNmu' :dialogVisibleBas="dialogVisibleBas" @closeDialog='closeDialog'/>
  </el-dialog>
</div>
</template>
<script type="text/javascript">
import publicBox from "@/components/businessManagementCenter/publicBox";
import {memberServicesRemaining} from "@/api";
export default {
  components: {
    publicBox
  },
  data() {
    return {
      tableData:[],
      dialogVisibleBas:false,
      serviceArr:[],
      memberNmu:false
    };
  },
  created() {
    this.search()
  },
  methods: {
    serviSurp(){
      if(this.serviceArr.length > 0){
        this.dialogVisibleBas = true;
        this.memberNmu = true
      }else{
        this.$message({
          message:'暂无服务信息',
          type:'warning'
        })
      }
    },
    closeDialog(val){
      this.dialogVisibleBas = val;
      this.memberNmu = false
      this.search();
    },
    closeTab(){
      this.$router.push('/basicDataCenter/baseInfo');
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (columnIndex === 1) {
        return "highLight";
      }
      return "";
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      if ((columnIndex === 0 || columnIndex === 1) && this.tableData.length > 0) {
        if (rowIndex % Number(this.tableData.length) === 0) {
          return {
            rowspan: Number(this.tableData.length),
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    async search(val) {
      let res = await memberServicesRemaining({
        memberPhone:this.$route.params.memberPhone,
      });
      if(res.code == 0){
        this.$message({
          message: res.msg,
          type: 'error'
        });
        return;
      }
      this.tableData = res.data && res.data?res.data:[];
      this.serviceArr = [];
      this.tableData.forEach(item => {
        let DataP = {
          id:item.id,
          orderId:item.orderId,
          memberId:item.memberId,
          memberName:item.memberName,
          memeberPhone:item.memberPhone,
          residueFrequency:item.residueFrequency,
          orderGoodsId:item.orderGoodsId,
          goodsId:item.goodsId,
          goodsName:item.goodsName
        }
        this.serviceArr.push(DataP);
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  }
};
</script>
<style lang="less" scoped>
.inServ {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  position: relative;
  .stepDet{margin:80px auto; text-align: center;
    p{text-indent: -6em;margin:0 0 20px;}
  }
  .uploadLists {
    display: inline-block;
  }
  .sucesOp{background: #67C23A;display: block;color: #fff;width:80px;height: 80px;line-height: 80px;text-align: center;border-radius: 8em;font-size:50px;font-weight: bolder;margin:0 auto;}
  .sucesOp2{display: block;text-align: center;font-size:30px;margin:20px auto 80px;}

}
</style>
<style lang="less">
.inServ {
  .el-upload-dragger{background-color:#f9f9f9;}
  .highLight {
    background: #eff1f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/baseServ.vue